const replaceLeadingSlash = (path: string) => {
  return path.replace(/^\/+/, '');
};

export const REFETCH_INTERVAL = 30000;

const getFetchData = (
  baseUrl: string,
  previewUser?: string,
  previewPassword?: string,
  cacheBusting?: boolean,
) => {
  return async <T>(path: string) => {
    let url = `${baseUrl}/${replaceLeadingSlash(path)}`;

    if (cacheBusting) {
      // round timestamp to REFETCH_INTERVAL seconds
      const timestamp = Math.floor(Date.now() / REFETCH_INTERVAL) * REFETCH_INTERVAL;
      url += `?${timestamp}`;
    }

    const headers: HeadersInit = {
      accept: 'application/json',
    };

    const response = await fetch(url, {
      headers,
      credentials: 'include',
    });

    const data = await response.json();

    if (data.error) {
      throw new Error(data.error);
    }

    return data as T;
  };
};

export default getFetchData;
